import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

import { splashCredit, SplashCredit } from '../utils/release-note-credit.util';

/** What the cover screen shows — the shape `SplashCard`, `SimpleReleaseNote` and `ReleaseNote` share. */
export interface ReleaseCover {
  version?: string;
  releaseDateLabel?: string;
  coverS3Reference?: string;
  artist?: string;
  grade?: string;
  family?: string;
  visiblePageCount?: number;
}

/**
 * The release cover (RA-2695; prototype `#rxIntro`): wordmark, version, "Research Management System", date,
 * the artwork credit and the actions on the left; the square cover art on the right. One component for the
 * modal's cover screen and the Library hero (`mode`), so the two cannot diverge — the prototype's DOM clone,
 * done properly. Nothing in the credit region assumes a fixed height: the note row is optional.
 */
@Component({
  selector: 'rms-release-cover',
  templateUrl: './release-cover.component.html',
  styleUrls: ['./release-cover.component.scss'],
  standalone: false
})
export class ReleaseCoverComponent implements OnChanges {

  @Input() public cover: ReleaseCover;
  @Input() public coverUrl: string | null = null;
  @Input() public mode: 'hero' | 'modal' = 'modal';
  @Input() public showSeeWhatsNew = false;
  /** Translate key for the secondary button; none when null. */
  @Input() public secondaryKey: string | null = null;
  /** The version heading's id, so the dialog can be labelled by it. */
  @Input() public labelId: string;

  @Output() public seeWhatsNew = new EventEmitter<void>();
  @Output() public secondary = new EventEmitter<void>();

  public credit: SplashCredit = { artist: '' };
  public artFailed = false;

  public ngOnChanges(): void {
    this.credit = splashCredit(this.cover?.artist, this.cover?.grade, this.cover?.family);
    this.artFailed = false;
  }
}
